// // src/api/index.js
// import axios from 'axios';
// //  export  const BASE_API_URL = 'https://hr.adityatrading.in/';  
// export const BASE_API_URL = 'http://localhost:8000/';
// export const MEDIA_API_URL = 'http://localhost:8000';
//export const BASE_API_URL = "https://hr.adityatrading.in/"  
//export const MEDIA_API_URL = "https://hr.adityatrading.in"  


// export const ADD_CANDIDATE = async (candidateData) => {
//   const response = await fetch(`${BASE_API_URL}create-candidate/`, {
//     method: 'POST',
//     headers: {
//       'Content-Type': 'multipart/form-data;boundary=----WebKitFormBoundary7MA4YWxkTrZu0gW',
//     },
//     body: JSON.stringify(candidateData),
//   });

//   if (!response.ok) {
//     throw new Error('Network response was not ok');
//   }

//   return response.json();
// };
// export const GetCandidateScheduledList = async () => {
//   try {
//     const response = await axios.get(`${BASE_API_URL}applications/`);
//     // console.log(response.data); // Log the response data
//     return response.data; // ✅ Return the actual data
//   } catch (error) {
//     console.error("Error fetching candidate scheduled list:", error);
//     throw new Error("Failed to fetch candidate scheduled list");
//   }
// };
// // Example of a function to fetch candidates
// export const getCandidates = async () => {
//   const response = await fetch(`${BASE_API_URL}get_candidates/`);

//   if (!response.ok) {
//     throw new Error('Network response was not ok');
//   }

//   return response.json();
// };

// export const SHEDULE_CANDIDATE = async (candidateData) => {
//   const formData = new FormData();

//   // Append each property to the FormData object
//   for (const key in candidateData) {
//     formData.append(key, candidateData[key]);
//   }

//   const response = await fetch(`${BASE_API_URL}submit/`, {
//     method: 'POST',
//     body: formData, // Use FormData directly
//     // Remove Content-Type; the browser will set it automatically
//   });

//   if (!response.ok) {
//     const errorMessage = await response.text(); // Optional: Get error message from response
//     throw new Error(`Error adding candidate: ${errorMessage}`);
//   }

//   return response.json();
// };

// // api/index.js
// export const GET_EMPLOYEE_DETAILS = async () => {
//   const response = await fetch('https://server.adityatrading.in/crm/api/get-employee-details');

//   if (!response.ok) {
//     throw new Error('Network response was not ok');
//   }

//   return response.json(); // Parse JSON data from the response
// };

// // api.js
// export const GET_All_EMPLOYEE_DETAILS = async () => {
//   const response = await fetch(`${BASE_API_URL}employees/`, {
//     method: 'GET',
//     headers: {
//       'Content-Type': 'application/json',
//     },
//   });

//   if (!response.ok) {
//     throw new Error(`HTTP error! Status: ${response.status}`);
//   }

//   return response.json(); // Parse the JSON data
// };

// export const UPDATE_PROGRESS_STATUS = async ({
//   applicationName,
//   status,
//   next_round,
//   rejection_reason,
//   interviewer_name,
//   interviewer_email,
//   interview_date,
//   interview_time,
// }) => {
//   const response = await axios.post(
//     `${BASE_API_URL}progressstatus/update/${applicationName}/`,
//     {
//       status,
//       ...(next_round && { next_round }), // Include nextRound if it exists
//       ...(rejection_reason && { rejection_reason }), // Include rejectionReason if it exists
//       interviewer_name,
//       interviewer_email,
//       interview_date,
//       interview_time,
//     }
//   );
//   return response.data; // Return the response data
// };

// export const SendEmail = async ({
//   name
// }) => {
//   const response = await axios.post(
//     `${BASE_API_URL}send-invitation/`,
//     {
//      name
//     }
//   );
//   return response.data; // Return the response data
// };

// export const createEmployee = async (formData) => {
//   const response = await axios.post(`${BASE_API_URL}create-employee/`, formData);
//   return response.data;
// };

// // Genrate payslip
// export const Genratepayslip = async (payload) => {
//   const response = await axios.post(`${BASE_API_URL}api/generate-payslips/`, payload);
//   return response.data;
// };

// // Function to fetch single employee details
// export const getSingleEmployee = async ({ queryKey }) => {
//   const [, id] = queryKey; // Destructure the query key to get the `id`
//   if (!id) throw new Error('Employee ID is required');
//   const response = await axios.get(`${BASE_API_URL}employee/${id}/`);
//   return response.data;
// };

// export const getpayslipEmployee = async ({ queryKey }) => {
//   const [, id] = queryKey; // Destructure the query key to get the `id`
//   if (!id) throw new Error('Employee ID is required');
//   const response = await axios.get(`${BASE_API_URL}employee/${id}/payslips/`);
//   return response.data;
// };

// export const getallPayslip = async () => {
//   const response = await axios.get(`${BASE_API_URL}get-all-payslips/`);
//   return response.data;
// };

// export const getSingleEmployeeDetails = async ({ queryKey }) => {
//   const [, id] = queryKey; // Destructure the query key to get the `id`
//   if (!id) throw new Error('Employee ID is required');
//   const response = await axios.get(`${BASE_API_URL}api/employee/${id}/`);
//   return response.data;
// };

// export const updateEmployeeDetails = async ({ employeeNo, formData }) => {
//   const response = await axios.put(`${BASE_API_URL}employee/${employeeNo}/`, formData);
//   return response.data;
// };

// export const raiseLeverequest = async ({ formData }) => {
//   const response = await axios.post(`${BASE_API_URL}leaverequest/employee/`, formData);
//   return response.data;
// };

// export const monthlyCTC = async ({ employee_no, monthly_ctc, amount, from_date, remarks ,pf}) => {
//   const response = await axios.post(`${BASE_API_URL}api/calculate-salary/`, {
//     employee_no, monthly_ctc, amount, from_date, remarks,pf
//   });
//   return response.data;
// };

// export const deleteEmployee = async (employeeNo) => {
//   try {
//     const response = await axios.delete(`${BASE_API_URL}delete-employee/${employeeNo}/`);
//     return response.data;
//   } catch (error) {
//     throw error.response?.data || error.message;
//   }
// };

// export const getCTCrevision = async ({ queryKey }) => {
//   const [, id] = queryKey; // Destructure the query key to get the `id`
//   if (!id) throw new Error('Employee ID is required');
//   const response = await axios.get(`${BASE_API_URL}employee/${id}/ctc-revisions/`);
//   return response.data;
// };

// export const deleteCTCrevision = async (id) => {
//   const response = await axios.delete(`${BASE_API_URL}api/delete-ctc-revision/${id}/`);
//   return response.data;
// };

// export const deletPayslip = async (id) => {
//   // console.log(id)
//   const payslip_id=id
//   const response = await axios.delete(`${BASE_API_URL}delete-pdf-file/${payslip_id}/`);
//   return response.data;
// };

// export const getSingleEmpLeave = async ({ queryKey }) => {
//   const [, id] = queryKey; // Destructure the query key to get the `id`

//   // Ensure `id` is provided
//   if (!id) throw new Error('Employee ID is required');

//   try {
//     const response = await axios.get(`${BASE_API_URL}getleaverequest/employee/${id}/`);
//     return response.data;
//   } catch (error) {
//     throw new Error(`Error fetching leave request data: ${error.message}`);
//   }
// };

// // Function to fetch all leave requests for admin
// export const getAdminLeaveRequests = async () => {
//   const response = await fetch(`${BASE_API_URL}adminleaverequest/`);
//   if (!response.ok) {
//     throw new Error('Error fetching admin leave requests');
//   }
//   return response.json(); // Returns the data (e.g., list of leave requests)
// };

// export const updateLeaveStatus = async ({ employee_no, status }) => {
//   const response = await axios.patch(
//     `${BASE_API_URL}updateleaverequest/${employee_no}/`, // Adjust API path as needed
//     { status }, // Request payload
//     { headers: { 'Content-Type': 'application/json' } } // Optional headers
//   );
//   return response.data; // Return updated data
// };
// // Helper to convert Excel serial date to YYYY-MM-DD string
// function excelDateToJSDate(serial) {
//   if (!serial || isNaN(serial)) return '';
//   const utc_days = Math.floor(serial - 25569);
//   const date_info = new Date(utc_days * 86400 * 1000);
//   return date_info.toISOString().split('T')[0]; // Returns "YYYY-MM-DD"
// }

// export const createExcelEmployeeData = async (employeeDataArray) => {
//   try {
//     for (const employeeData of employeeDataArray) {
//       const formData = new FormData();

//       // Convert Excel serial date fields
//       if (employeeData['DOJ']) {
//         employeeData['DOJ'] = excelDateToJSDate(employeeData['DOJ']);
//       }
//       if (employeeData['DOB']) {
//         employeeData['DOB'] = excelDateToJSDate(employeeData['DOB']);
//       }
//       if (employeeData['Confirmation Date']) {
//         employeeData['Confirmation Date'] = excelDateToJSDate(employeeData['Confirmation Date']);
//       }

//       // Append all fields to FormData
//       Object.keys(employeeData).forEach((key) => {
//         formData.append(key, employeeData[key]);
//       });

//       const response = await axios.post(`${BASE_API_URL}upload_employee_data_ui/`, formData, {
//         headers: {
//           'Content-Type': 'multipart/form-data',
//         },
//       });

//       if (response.status === 200) {
//         console.log(`Employee ${employeeData['Emp ID']} uploaded successfully`);
//       } else {
//         console.error(`Failed to upload Employee ${employeeData['Emp ID']}`);
//       }
//     }
//   } catch (error) {
//     console.error('An error occurred during the upload:', error);



// export const createExcelBankEmployeeData = async (employeeDataArray) => {
//   try {
//     // console.log(employeeDataArray);
//     const response = await axios.post(`${BASE_API_URL}upload_employee_salary_ui/`, employeeDataArray, {
//       headers: {
//         'Content-Type': 'application/json',
//       },
//     });

//     if (response.status === 200) {
//       // console.log("Employee data uploaded successfully");
//     } else {
//       console.error("Failed to upload employee data");
//     }
//   } catch (error) {
//     console.error("An error occurred during the upload:", error);
//     throw error; // Rethrow to be handled in onError
//   }
// };

// export const getEmpLeaveRequests = async (id) => {
//   try {
//     const response = await axios.get(`${BASE_API_URL}getleaverequest/recipient/${id}/`);
//     // console.log(response); // Logs the full response
//     return response.data;  // Return the data (not the entire response object)
//   } catch (error) {
//     console.error('Error fetching employee leave requests:', error); // Log any error
//     throw error; // Rethrow to let `useQuery` handle the error
//   }
// };

// export const updateEmpLeaveStatus = async ({ employee_no, status }) => {
//   const response = await axios.patch(
//     `${BASE_API_URL}respondleaverequest/${employee_no}/`, // Adjust API path as needed
//     { status }, // Request payload
//     { headers: { 'Content-Type': 'application/json' } } // Optional headers
//   );
//   return response.data; // Return updated data
// };

// export const getCCLeaveRequests=async({queryKey})=>{
//   const [,id]=queryKey;
//   if(!id) throw new Error('Employee ID is required');
//   const response= await axios.get(`${BASE_API_URL}leaverequest/cc/${id}/`);
//   return response.data;
// }

// export const updatepassword = async ({ employee_no, old_password,new_password }) => {

// const response = await axios.post(`${BASE_API_URL}update-password/`, {employee_no, old_password,new_password});
// return response.data;
// };



// export const updatePhoto = async ({ employee_no, file }) => {
//   try {
//     const formData = new FormData();
//     formData.append("employee_no", employee_no);
//     formData.append("photo", file); // Append the image file

//     const response = await axios.post(`${BASE_API_URL}update-photo/`, formData, {
//       headers: {
//         "Content-Type": "multipart/form-data", // Required for file uploads
//       },
//     });

//     return response.data; // Return response data
//   } catch (error) {
//     throw error.response ? error.response.data : error.message;
//   }
// };

// export const resignedEmp=async()=>{
//   try {
//     const response= await axios.get(`${BASE_API_URL}resigned-employees/`);
//     return response.data;
//   } catch (error) {
//     throw error.response ? error.response.data : error.message;
//   }
// }


// export const uploadDocument = async ({ employee_no, file,file_type }) => {
//   try {
//     const formData = new FormData();
//     formData.append("employee_no", employee_no);
//     formData.append("file", file); 
//     formData.append("file_type", file_type);
//     const response = await axios.post(`${BASE_API_URL}upload-document/${employee_no}/`, formData, {
//       headers: {
//         "Content-Type": "multipart/form-data", 
//       },
//     });

//     return response.data; 
//   } catch (error) {
//     throw error.response ? error.response.data : error.message;
//   }
// };



//New API  for Token 

// src/api/index.js
import axios from 'axios';
import { tenantApiBase } from '../context/CompanyContext';
import { handleUnauthorized, isPublicAuthRequest, readAuthData } from '../utils/authStorage';

const _rawBase = process.env.REACT_APP_API_URL || 'https://hr.adityatrading.in/';
export const BASE_API_URL = _rawBase;
export const MEDIA_API_URL = (process.env.REACT_APP_API_URL || 'https://hr.adityatrading.in').replace(/\/$/, '');


export const axiosInstance = axios.create({
  baseURL: _rawBase,
});

export const getActivityLogs = async (params = {}) => {
  const response = await axiosInstance.get('api/activity-logs/', { params });
  return response.data;
};
// Tenant-scoped API base ("https://hr.../ats001/"). BASE_API_URL itself has no
// company code, so any request built by hand (fetch, absolute axios URL) must
// go through apiUrl() or it lands on the default company instead of this one.
const tenantBase = () => tenantApiBase(_rawBase);
export const apiUrl = (path) => `${tenantBase()}${String(path).replace(/^\//, '')}`;

axiosInstance.interceptors.request.use((config) => {
  config.baseURL = tenantBase();
  const data = readAuthData();
  const token = data?.admin?.Token || data?.token;
  if (token && !isPublicAuthRequest(config.url)) config.headers.Authorization = `Bearer ${token}`;
  return config;
});
// Instant mid-session block: when the backend rejects a resigned/inactive
// employee's token (401 + code ACCOUNT_DEACTIVATED), clear the session and
// reload so the app re-renders the login screen (shown when authData is gone).
// Scoped to that exact code so it never hijacks other 401s (e.g. wrong password).
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error?.response?.status === 401) handleUnauthorized(error?.config?.url);
    return Promise.reject(error);
  }
);
export const getEmployeeByToken = async (token) => {
  const response = await axiosInstance.get(`employee-form/${token}/`);
  return response.data;
};

// Upload a joining-form document via the token (NOT employee_no) — the joining
// form is a public capability link and a new hire has no JWT, so it must post to
// the token-gated /employee-form/<token>/ endpoint (which the JWT middleware
// treats as public) rather than the auth-gated /upload-document/<employee_no>/.
export const uploadJoiningDocument = async ({ token, file, file_type }) => {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('file_type', file_type);
  const response = await axiosInstance.post(`employee-form/${token}/`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return response.data;
};

// Save the editable joining-form field details (JSON PATCH via the same public
// token endpoint). No file => the view routes to EmployeeFormSerializer.
export const submitJoiningForm = async (token, fields) => {
  const response = await axiosInstance.post(`employee-form/${token}/`, fields, {
    headers: { 'Content-Type': 'application/json' },
  });
  return response.data;
};

// ---------------------------------------------------------------------------
// Automated Employee Onboarding
// ---------------------------------------------------------------------------
// HR-facing (require a logged-in admin/HR token — axiosInstance attaches it).
export const getOnboardingList = async (params = {}) => {
  const response = await axiosInstance.get('api/onboarding/', { params });
  return response.data;
};

export const getOnboardingDetail = async (employeeNo) => {
  const response = await axiosInstance.get(`api/onboarding/${encodeURIComponent(employeeNo)}/`);
  return response.data;
};

export const sendOnboardingPack = async (employeeNo) => {
  const response = await axiosInstance.post(`api/onboarding/${encodeURIComponent(employeeNo)}/send/`);
  return response.data;
};

export const verifyOnboardingDocumentIntegrity = async (documentId) => {
  const response = await axiosInstance.get(`api/onboarding/documents/${documentId}/integrity/`);
  return response.data;
};

export const reviewOnboardingKyc = async (itemId, status, rejectionReason = '') => {
  const response = await axiosInstance.post(`api/v1/onboarding/kyc/${itemId}/review/`, {
    status,
    rejection_reason: rejectionReason,
  });
  return response.data;
};

export const downloadOnboardingKyc = async (itemId) => {
  const response = await axiosInstance.get(`api/v1/onboarding/kyc/${itemId}/file/`, {
    responseType: 'blob',
  });
  return response.data;
};

// Candidate (pre-join) onboarding — from the Selected Candidates page.
// `terms` = { designation, annual_salary, date_of_joining } (all optional).
export const sendCandidateOnboarding = async (applicationId, terms = {}) => {
  const response = await axiosInstance.post(`api/onboarding/candidate/${applicationId}/send/`, terms);
  return response.data;
};

export const getCandidateOnboarding = async (applicationId) => {
  const response = await axiosInstance.get(`api/onboarding/candidate/${applicationId}/`);
  return response.data;
};

// Preview a letter (doc: 'offer_letter' | 'appointment_letter') as a PDF, or the
// onboarding email (doc: 'email') as HTML — returned as a Blob to open in a tab.
export const previewCandidateLetter = async (applicationId, params) => {
  const response = await axiosInstance.get(`api/onboarding/candidate/${applicationId}/preview/`, {
    params, responseType: 'blob',
  });
  return response.data;
};

// Joined -> activate the prospective employee (portal access); Dropped -> resign it.
// employee_no (optional): the real employee number HR assigns at Joined (the record
// carried a hidden ONB-<id> placeholder until now).
export const markCandidateJoined = async (applicationId, employee_no) => {
  const body = employee_no ? { employee_no } : {};
  const response = await axiosInstance.post(`api/onboarding/candidate/${applicationId}/joined/`, body);
  return response.data;
};

export const markCandidateDropped = async (applicationId) => {
  const response = await axiosInstance.post(`api/onboarding/candidate/${applicationId}/dropped/`);
  return response.data;
};

// Employee-facing (passwordless capability links — token in the URL is the secret).
export const getSignDocument = async (signToken) => {
  const response = await axiosInstance.get(`api/onboarding/sign/${signToken}/`);
  return response.data;
};

// Rasterized page images of the document, for the drag-and-drop placement editor.
export const getSignPages = async (signToken) => {
  const response = await axiosInstance.get(`api/onboarding/sign/${signToken}/pages/`);
  return response.data;
};

export const submitSignature = async (signToken, { signature, signer_name, placements }) => {
  const response = await axiosInstance.post(`api/onboarding/sign/${signToken}/submit/`, {
    signature,
    signer_name,
    placements,
  });
  return response.data;
};

export const getOnboardingKyc = async (token) => {
  const response = await axiosInstance.get(`api/onboarding/upload/${token}/`);
  return response.data;
};

export const uploadOnboardingKyc = async (token, docKey, file) => {
  const formData = new FormData();
  formData.append('doc_key', docKey);
  formData.append('file', file);
  const response = await axiosInstance.post(`api/onboarding/upload/${token}/submit/`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return response.data;
};


export const ADD_CANDIDATE = async (candidateData) => {
  const response = await axiosInstance.post('create-candidate/', candidateData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return response.data;
};

export const GetCandidateScheduledList = async () => {
  const response = await axiosInstance.get('applications/');
  return response.data;
};

// Delete a scheduled candidate (interview application) by its id.
export const DELETE_INTERVIEW_APPLICATION = async (id) => {
  const response = await axiosInstance.delete(`applications/${id}/`);
  return response.data;
};

export const getCandidates = async () => {
  const response = await axiosInstance.get('get_candidates/');
  return response.data;
};

export const SHEDULE_CANDIDATE = async (candidateData) => {
  const formData = new FormData();
  for (const key in candidateData) {
    const value = candidateData[key];
    // Skip null/undefined so empty fields (e.g. no resume) aren't sent as the
    // string "null" — which the file field would reject with a 400.
    if (value !== null && value !== undefined) {
      formData.append(key, value);
    }
  }
  const response = await axiosInstance.post('submit/', formData);
  return response.data;
};

// Preview the "interview scheduled" email (To: candidate, Cc: interviewer + HR)
// without sending — drives the schedule flow's preview dialog. Pass the record
// `id` so the backend pins the exact candidate (names are non-unique); `name`
// is a fallback.
export const PREVIEW_INTERVIEW_EMAIL = async ({ id, name }) => {
  const response = await axiosInstance.post('interview-email/', { id, name, preview: true });
  return response.data;
};

// Send the interview-scheduled email after HR confirms the preview.
export const SEND_INTERVIEW_EMAIL = async ({ id, name, subject, html, text, cc }) => {
  const payload = { id, name, subject, html, text };
  // Cc is editable in the preview; mark it authoritative (empty => no Cc).
  if (Array.isArray(cc)) {
    payload.cc_provided = true;
    payload.cc = cc;
  }
  const response = await axiosInstance.post('interview-email/', payload);
  return response.data;
};

// Send the "moved to next round" mail after HR reviews the preview.
// cc (when an array) overrides the default Cc; an empty array means "no Cc".
export const SEND_ROUND_EMAIL = async (applicationName, cc) => {
  const body = {};
  if (Array.isArray(cc)) {
    body.cc_provided = true;
    body.cc = cc;
  }
  const response = await axiosInstance.post(`progressstatus/send-round-email/${applicationName}/`, body);
  return response.data;
};

export const GET_EMPLOYEE_DETAILS = async () => {
  const response = await axiosInstance.get('https://server.adityatrading.in/crm/api/get-employee-details');
  return response.data;
};

export const GET_All_EMPLOYEE_DETAILS = async () => {
  const response = await axiosInstance.get('employees/');
  return response.data;
};

export const GET_LITE_EMPLOYEE_DETAILS = async () => {
  const response = await axiosInstance.get('employees/?lite=true');
  return response.data;
};

export const GET_REPORTING_MANAGER_OPTIONS = async () => {
  const response = await axiosInstance.get('employees/?lite=true&manager_options=true');
  return response.data;
};

// Same lite shape, but includes resigned (inactive) employees and the `resigned`
// flag — used by the Contacts directory to label Active / Inactive.
export const GET_LITE_EMPLOYEE_DETAILS_ALL = async () => {
  const response = await axiosInstance.get('employees/?lite=true&include_resigned=true');
  return response.data;
};

// ----- Reusable LOP uploads (saved after a successful payroll process) -----
export const saveLopUpload = async ({ file, month, year, filtersLabel, lopData, uploadedBy } = {}) => {
  const fd = new FormData();
  if (file) fd.append('file', file);
  fd.append('month', month || '');
  fd.append('year', year || '');
  fd.append('filters_label', filtersLabel || 'All');
  if (uploadedBy) fd.append('uploaded_by', uploadedBy);
  fd.append('lop_data', JSON.stringify(lopData || []));
  const response = await axiosInstance.post('api/lop-uploads/', fd, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return response.data;
};

export const getRecentLopUploads = async () => {
  const response = await axiosInstance.get('api/lop-uploads/');
  return response.data?.results || [];
};

export const getLopUpload = async (id) => {
  const response = await axiosInstance.get(`api/lop-uploads/${id}/`);
  return response.data;
};

export const deleteLopUpload = async (id) => {
  const response = await axiosInstance.delete(`api/lop-uploads/${id}/`);
  return response.data;
};

// Create DRAFT payslips directly from a filled "Salary Details" Excel. Values are
// used verbatim (no LOP/proration recalculation); the resulting payslips then flow
// through Generate PDFs / Publish / Email like any other. Returns
// { created, skipped, unmatched_employee_nos, mapped_fields }.
export const importSalaryPayslips = async ({ file, month, year } = {}) => {
  const fd = new FormData();
  if (file) fd.append('file', file);
  fd.append('month', month || '');
  fd.append('year', year || '');
  const response = await axiosInstance.post('api/import-salary-payslips/', fd, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return response.data;
};

// Payslip Finalization: merge the four team salary files (HO, Vinod, Sathish, MDH)
// into one consolidated workbook. `files` is keyed by slot ({ ho, vinod, sathish, mdh }).
// Resolves { filename, file_base64, summary }; a 400 carries { error, missing,
// file_errors, problems } describing exactly what to fix.
export const mergeSalaryFiles = async ({ files = {}, month, year, onUploadProgress } = {}) => {
  const fd = new FormData();
  Object.entries(files).forEach(([slot, file]) => {
    if (file) fd.append(`file_${slot}`, file);
  });
  if (month) fd.append('month', month);
  if (year) fd.append('year', year);
  const response = await axiosInstance.post('api/payroll/merge-salary-files/', fd, {
    headers: { 'Content-Type': 'multipart/form-data' },
    onUploadProgress,
  });
  return response.data;
};

// Download the processed Bank + Salary report (one xlsx, two sheets) for a single
// batch (uploadId) or every batch of the month (scope: 'all').
export const downloadPayrollReport = async ({ month, year, uploadId, uploadIds, scope, label } = {}) => {
  const params = { month, year };
  if (uploadIds && uploadIds.length) params.upload_ids = Array.isArray(uploadIds) ? uploadIds.join(',') : uploadIds;
  else if (scope) params.scope = scope;
  else if (uploadId) params.upload_id = uploadId;
  const response = await axiosInstance.get('api/lop-upload-report/', { params, responseType: 'blob' });
  const url = window.URL.createObjectURL(new Blob([response.data]));
  const link = document.createElement('a');
  link.href = url;
  const tag = (label || (scope ? 'ALL' : uploadId) || 'report').toString().replace(/[^\w-]+/g, '-');
  link.setAttribute('download', `PayrollReport_${tag}_${month}_${year}.xlsx`);
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
};

export const UPDATE_PROGRESS_STATUS = async ({
  applicationName,
  status,
  next_round,
  rejection_reason,
  interviewer_name,
  interviewer_email,
  interview_date,
  interview_time,
  round_number,
  meeting_link,
  hr_cc_name,
  hr_cc_email,
}) => {
  const response = await axiosInstance.post(`progressstatus/update/${applicationName}/`, {
    status,
    ...(next_round && { next_round }),
    ...(rejection_reason && { rejection_reason }),
    interviewer_name,
    interviewer_email,
    interview_date,
    interview_time,
    ...(round_number && { round_number }),
    ...(meeting_link && { meeting_link }),
    // Sent unconditionally (including empty) so HR CC can be cleared, not only set.
    hr_cc_name,
    hr_cc_email,
  });
  return response.data;
};

// Set a selected candidate's post-offer outcome: 'joined' | 'rejected' | '' (clear)
export const UPDATE_FINAL_STATUS = async ({ name, status }) => {
  const response = await axiosInstance.post(`final-status/${encodeURIComponent(name)}/`, { status });
  return response.data;
};

export const SendEmail = async ({ name, subject, html, text, attachments, templateLabel, templateId, cc }) => {
  const formData = new FormData();
  formData.append('name', name);
  if (subject) formData.append('subject', subject);
  if (html) formData.append('html', html);
  if (text) formData.append('text', text);
  if (templateLabel) formData.append('template_label', templateLabel);
  if (templateId) formData.append('template_id', templateId);
  // Cc is user-editable in the composer; mark it authoritative so an empty
  // list means "no Cc" instead of the server default.
  if (Array.isArray(cc)) {
    formData.append('cc_provided', 'true');
    cc.forEach((addr) => addr && formData.append('cc', addr));
  }
  (attachments || []).forEach((file) => formData.append('attachments', file));
  const response = await axiosInstance.post('send-invitation/', formData);
  return response.data;
};

export const createEmployee = async (formData) => {
  const response = await axiosInstance.post('create-employee/', formData);
  return response.data;
};

export const Genratepayslip = async (payload) => {
  const response = await axiosInstance.post('api/generate-payslips/', payload);
  return response.data;
};

export const generatePayslipPdfs = async (payload) => {
  const response = await axiosInstance.post('api/generate-payslip-pdfs/', payload);
  return response.data;
};

export const publishPayslips = async (payload) => {
  const response = await axiosInstance.post('api/publish-payslips/', payload);
  return response.data;
};

// Preview which employees a payslip email would go to (no send). Accepts
// { payslip_id } | { payslip_ids } | { month, year }.
export const previewPayslipEmails = async (payload) => {
  const response = await axiosInstance.post('api/email-payslips/', { ...payload, preview: true });
  return response.data;
};

// Actually email the (PUBLISHED) payslips. Same selector shapes as preview.
export const sendPayslipEmails = async (payload) => {
  const response = await axiosInstance.post('api/email-payslips/', payload);
  return response.data;
};

export const getSingleEmployee = async ({ queryKey }) => {
  const [, id] = queryKey;
  if (!id) throw new Error('Employee ID is required');
  const response = await axiosInstance.get(`employee/${id}/`);
  return response.data;
};

export const getEmployeeTimeline = async ({ queryKey }) => {
  const [, employeeNo] = queryKey;
  if (!employeeNo) throw new Error('Employee ID is required');
  const response = await axiosInstance.get(
    `api/v1/employees/${employeeNo}/timeline/`
  );
  return response.data;
};

export const updateEmployeeDetails = async ({ employeeNo, formData }) => {
  const response = await axiosInstance.put(`employee/${employeeNo}/`, formData);
  return response.data;
};

export const resignedEmp = async () => {
  const response = await axiosInstance.get('resigned-employees/');
  return response.data;
};

export const updatePhoto = async ({ employee_no, file }) => {
  const formData = new FormData();
  formData.append("employee_no", employee_no);
  formData.append("photo", file);
  const response = await axiosInstance.post('update-photo/', formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return response.data;
};

export const getpayslipEmployee = async ({ queryKey }) => {
  const [, id] = queryKey;
  if (!id) throw new Error('Employee ID is required');
  const response = await axiosInstance.get(`employee/${id}/payslips/`);
  return response.data;
};

export const getallPayslip = async (params = {}) => {
  const { page = 1, month, year, search, page_size, status, employee_no, department } = params;
  const queryParams = new URLSearchParams({ page });
  if (month) queryParams.append('month', month);
  if (year) queryParams.append('year', year);
  if (search) queryParams.append('search', search);
  if (status) queryParams.append('status', status);
  if (page_size) queryParams.append('page_size', page_size);
  if (employee_no) queryParams.append('employee_no', employee_no);
  if (department) queryParams.append('department', department);

  const response = await axiosInstance.get(`get-all-payslips/?${queryParams.toString()}`);
  return response.data;
};

export const getSalaryPreview = async ({ employeeNo, month, year }) => {
  const response = await axiosInstance.get(`api/salary-preview/${employeeNo}/`, {
    params: { month, year },
  });
  return response.data;
};

export const getSingleEmployeeDetails = async ({ queryKey }) => {
  const [, id] = queryKey;
  if (!id) throw new Error('Employee ID is required');
  const response = await axiosInstance.get(`api/employee/${id}/`);
  return response.data;
};

export const getEmployeePublishedPayslips = async ({ queryKey }) => {
  const [, id] = queryKey;
  if (!id) throw new Error('Employee ID is required');
  const response = await axiosInstance.get(`api/my-payslips/${id}/`);
  return response.data;
};

export const raiseLeverequest = async ({ formData }) => {
  const response = await axiosInstance.post('leaverequest/employee/', formData);
  return response.data;
};

export const monthlyCTC = async ({ employee_no, monthly_ctc, amount, from_date, remarks, pf }) => {
  const response = await axiosInstance.post('api/calculate-salary/', {
    employee_no, monthly_ctc, amount, from_date, remarks, pf
  });
  return response.data;
};

export const deleteEmployee = async (employeeNo) => {
  const response = await axiosInstance.delete(`delete-employee/${employeeNo}/`);
  return response.data;
};

export const resignEmployee = async ({ employeeNo, formData }) => {
  const response = await axiosInstance.post(`delete-employee/${employeeNo}/`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return response.data;
};

export const reactivateEmployee = async (employeeNo) => {
  const response = await axiosInstance.post(`reactivate-employee/${employeeNo}/`);
  return response.data;
};

export const getCTCrevision = async ({ queryKey }) => {
  const [, id] = queryKey;
  if (!id) throw new Error('Employee ID is required');
  const response = await axiosInstance.get(`employee/${id}/ctc-revisions/`);
  return response.data;
};

export const deleteCTCrevision = async (id) => {
  const response = await axiosInstance.delete(`api/delete-ctc-revision/${id}/`);
  return response.data;
};

export const deletPayslip = async (id) => {
  const response = await axiosInstance.delete(`delete-pdf-file/${id}/`);
  return response.data;
};

export const getSingleEmpLeave = async ({ queryKey }) => {
  const [, id] = queryKey;
  if (!id) throw new Error('Employee ID is required');
  const response = await axiosInstance.get(`getleaverequest/employee/${id}/`);
  return response.data;
};

export const getAdminLeaveRequests = async () => {
  const response = await axiosInstance.get('adminleaverequest/');
  return response.data;
};

export const updateLeaveStatus = async ({ leave_request_id, status, status_reason }) => {
  const response = await axiosInstance.patch(`updateleaverequest/${leave_request_id}/`, { status, status_reason });
  return response.data;
};

export const getLeaveSummaryReport = async () => {
  const response = await axiosInstance.get('leave-summary-report/');
  return response.data;
};

export const updateEmployeeLeaves = async ({ employeeNo, leaveData }) => {
  const response = await axiosInstance.put(`api/employees/${employeeNo}/update-leaves/`, leaveData);
  return response.data;
};

export const exportLeaveSummary = async () => {
  const response = await axiosInstance.get('api/export-leave-summary/', {
    responseType: 'blob',
  });
  const url = window.URL.createObjectURL(new Blob([response.data]));
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', `Leave_Summary_${new Date().toISOString().split('T')[0]}.xlsx`);
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
};

export const downloadLeaveTemplate = async () => {
  const response = await axiosInstance.get('api/leave-import-template/', {
    responseType: 'blob',
  });
  const url = window.URL.createObjectURL(new Blob([response.data]));
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', 'Leave_Import_Template.xlsx');
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
};

export const bulkUpdateLeaves = async (file) => {
  const formData = new FormData();
  formData.append('file', file);
  const response = await axiosInstance.post('api/bulk-update-leaves/', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return response.data;
};

// ===== Attendance =====

export const uploadAttendance = async (file) => {
  const formData = new FormData();
  formData.append('file', file);
  const response = await axiosInstance.post('api/attendance/upload/', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return response.data;
};

export const downloadAttendanceTemplate = async () => {
  const response = await axiosInstance.get('api/attendance/template/', {
    responseType: 'blob',
  });
  const url = window.URL.createObjectURL(new Blob([response.data]));
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', 'Attendance_Import_Template.xlsx');
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
};

export const downloadAttendanceExport = async ({ startDate, endDate, department, employeeNo, branch, teamHead, manager, search } = {}) => {
  const params = new URLSearchParams();
  if (startDate) params.append('start_date', startDate);
  if (endDate) params.append('end_date', endDate);
  if (department && department !== 'All') params.append('department', department);
  if (branch && branch.toLowerCase() !== 'all') params.append('branch', branch);
  if (teamHead && teamHead.toLowerCase() !== 'all') params.append('team_head', teamHead);
  if (manager && manager.toLowerCase() !== 'all') params.append('manager', manager);
  if (employeeNo) params.append('employee_no', employeeNo);
  if (search) params.append('search', search);
  const response = await axiosInstance.get(`api/attendance/export/?${params.toString()}`, {
    responseType: 'blob',
  });
  const url = window.URL.createObjectURL(new Blob([response.data]));
  const link = document.createElement('a');
  link.href = url;
  const range = endDate && endDate !== startDate ? `${startDate}_to_${endDate}` : (startDate || 'all');
  const tag = (v) => (v && v.toLowerCase() !== 'all' ? `_${String(v).replace(/[^\w-]+/g, '-')}` : '');
  link.setAttribute('download', `Attendance_${range}${tag(branch)}${tag(teamHead)}${tag(manager)}.xlsx`);
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
};

export const getMonthlyAttendance = async (params = {}) => {
  const response = await axiosInstance.get('api/attendance/monthly/', { params });
  return response.data;
};

export const downloadMonthlyAttendanceExport = async ({ cycle, month, year, department, branch, teamHead, manager, search } = {}) => {
  const params = new URLSearchParams();
  // When a cycle ("YYYY-MM") is given, the backend exports exactly the 26→25
  // cycle range (e.g. 26 May – 25 Jun) instead of the calendar month. month/year
  // are still sent as a fallback for the filename + older callers.
  if (cycle) params.append('cycle', cycle);
  if (month) params.append('month', month);
  if (year) params.append('year', year);
  if (department && department !== 'All') params.append('department', department);
  if (branch && branch.toLowerCase() !== 'all') params.append('branch', branch);
  if (teamHead && teamHead.toLowerCase() !== 'all') params.append('team_head', teamHead);
  if (manager && manager.toLowerCase() !== 'all') params.append('manager', manager);
  if (search) params.append('search', search);
  const response = await axiosInstance.get(`api/attendance/monthly-export/?${params.toString()}`, {
    responseType: 'blob',
  });
  const url = window.URL.createObjectURL(new Blob([response.data]));
  const link = document.createElement('a');
  link.href = url;
  const tag = (v) => (v && v.toLowerCase() !== 'all' ? `_${String(v).replace(/[^\w-]+/g, '-')}` : '');
  const period = cycle ? `Cycle_${cycle}` : `${month || ''}-${year || ''}`;
  link.setAttribute('download', `Monthly_Attendance_${period}${tag(branch)}${tag(teamHead)}${tag(manager)}.xlsx`);
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
};

export const getEmployeeAttendanceHistory = async (employeeNo, params = {}) => {
  const response = await axiosInstance.get(`api/attendance/employee/${employeeNo}/`, { params });
  return response.data;
};

export const overrideAttendance = async (attendanceId, payload) => {
  const response = await axiosInstance.patch(`api/attendance/${attendanceId}/`, payload);
  return response.data;
};

// ----- 25→25 cycle dashboards + auto-LOP -----

export const getCycleAttendance = async (params = {}) => {
  const response = await axiosInstance.get('api/attendance/cycle-summary/', { params });
  return response.data;
};

export const getEmployeeCycleAttendance = async (employeeNo, params = {}) => {
  const response = await axiosInstance.get(`api/attendance/employee/${employeeNo}/cycle/`, { params });
  return response.data;
};

export const getEmployeeYearSummary = async (employeeNo, params = {}) => {
  const response = await axiosInstance.get(`api/attendance/employee/${employeeNo}/year-summary/`, { params });
  return response.data;
};

export const downloadLopTemplate = async (params = {}) => {
  const response = await axiosInstance.get('api/attendance/lop-template/', {
    params,
    responseType: 'blob',
  });
  const url = window.URL.createObjectURL(new Blob([response.data]));
  const link = document.createElement('a');
  link.href = url;
  const lbl = (params.label && params.label !== 'All') ? `_${params.label}` : '';
  const cyc = params.cycle ? `_${params.cycle}` : '';
  link.setAttribute('download', `LOP_Template${lbl}${cyc}.xlsx`);
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
};

export const createExcelEmployeeData = async (employeeDataArray) => {
  for (const employeeData of employeeDataArray) {
    const formData = new FormData();
    if (employeeData['DOJ']) employeeData['DOJ'] = excelDateToJSDate(employeeData['DOJ']);
    if (employeeData['DOB']) employeeData['DOB'] = excelDateToJSDate(employeeData['DOB']);
    if (employeeData['Confirmation Date']) employeeData['Confirmation Date'] = excelDateToJSDate(employeeData['Confirmation Date']);
    Object.keys(employeeData).forEach((key) => {
      formData.append(key, employeeData[key]);
    });

    await axiosInstance.post('upload_employee_data_ui/', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  }
};

export const createExcelBankEmployeeData = async (employeeDataArray) => {
  const response = await axiosInstance.post('upload_employee_salary_ui/', employeeDataArray, {
    headers: { 'Content-Type': 'application/json' },
  });
  return response.data;
};

export const uploadBulkEmployeeMaster = async (file) => {
  const formData = new FormData();
  formData.append('file', file);
  const response = await axiosInstance.post('api/bulk-employee-master-upload/', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return response.data;
};

// ========================================
// DETAILED SALARY REPORT (admin)
// ========================================

const buildDetailedSalaryParams = ({ mode, month, year, search, branch, department, manager_id, team_head, page, pageSize } = {}) => {
  const params = new URLSearchParams();
  if (mode) params.append('mode', mode);
  if (mode === 'paid') {
    if (month) params.append('month', month);
    if (year) params.append('year', year);
  }
  if (search) params.append('search', search);
  if (branch) params.append('branch', branch);
  if (department) params.append('department', department);
  if (manager_id) params.append('manager_id', manager_id);
  if (team_head) params.append('team_head', team_head);
  if (page) params.append('page', page);
  if (pageSize) params.append('page_size', pageSize);
  return params;
};

export const getDetailedSalaryReport = async (filters = {}) => {
  const params = buildDetailedSalaryParams(filters);
  const response = await axiosInstance.get(`api/detailed-salary-report/?${params.toString()}`);
  return response.data;
};

export const downloadDetailedSalaryReport = async (filters = {}) => {
  const params = buildDetailedSalaryParams(filters);
  const response = await axiosInstance.get(`api/detailed-salary-report/export/?${params.toString()}`, {
    responseType: 'blob',
  });

  const url = window.URL.createObjectURL(new Blob([response.data]));
  const link = document.createElement('a');
  link.href = url;
  const today = new Date().toISOString().split('T')[0];
  const suffix = filters.mode === 'paid' && filters.month && filters.year
    ? `paid_${filters.year}_${filters.month}`
    : `structure_${today}`;
  link.setAttribute('download', `detailed_salary_report_${suffix}.xlsx`);
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
};

export const exportEmployeeMasterData = async (filters = {}) => {
  const params = new URLSearchParams();
  Object.keys(filters).forEach(key => {
    if (filters[key]) params.append(key, filters[key]);
  });

  const response = await axiosInstance.get(`api/export-employee-master-data/?${params.toString()}`, {
    responseType: 'blob',
  });

  const url = window.URL.createObjectURL(new Blob([response.data]));
  const link = document.createElement('a');
  link.href = url;
  const status = ['active', 'inactive'].includes(filters.record_status) ? filters.record_status : 'all';
  const filename = filters.template
    ? 'employee_upload_template.xlsx'
    : `${status}_employee_master_${new Date().toISOString().split('T')[0]}.xlsx`;
  link.setAttribute('download', filename);
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
};

export const getEmpLeaveRequests = async (id) => {
  const response = await axiosInstance.get(`getleaverequest/recipient/${id}/`);
  return response.data;
};

export const getDirectTeamMembers = async () => {
  const response = await axiosInstance.get('api/team/members/');
  return response.data;
};

export const updateEmpLeaveStatus = async ({ leave_request_id, status, status_reason }) => {
  const response = await axiosInstance.patch(`respondleaverequest/${leave_request_id}/`, { status, status_reason });
  return response.data;
};

// Cancel/withdraw a leave (restores balance). actor='HR' lets an admin cancel any
// employee's leave; omit it (or 'employee') for the self-service employee flow.
export const withdrawLeaveRequest = async ({ leave_request_id, employee_no, reason, actor }) => {
  const response = await axiosInstance.patch(`withdrawleaverequest/${leave_request_id}/`, { employee_no, reason, actor });
  return response.data;
};

export const getCCLeaveRequests = async ({ queryKey }) => {
  const [, id] = queryKey;
  if (!id) throw new Error('Employee ID is required');
  const response = await axiosInstance.get(`leaverequest/cc/${id}/`);
  return response.data;
};

export const updateWorkdays = async (data) => {
  const response = await axiosInstance.post('api/update-workdays/', data);
  return response.data;
};

export const updatepassword = async ({ employee_no, old_password, new_password }) => {
  const response = await axiosInstance.post('update-password/', { employee_no, old_password, new_password });
  return response.data;
};

export const uploadDocument = async ({ employee_no, file, file_type }) => {
  const formData = new FormData();
  formData.append("employee_no", employee_no);
  formData.append("file", file);
  formData.append("file_type", file_type);
  const response = await axiosInstance.post(`upload-document/${employee_no}/`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return response.data;
};


export const getEmployeesWithoutSalary = async () => {
  const response = await axiosInstance.get('employees-without-salary/');
  return response.data;
};

function excelDateToJSDate(serial) {
  if (!serial || isNaN(serial)) return '';
  const utc_days = Math.floor(serial - 25569);
  const date_info = new Date(utc_days * 86400 * 1000);
  return date_info.toISOString().split('T')[0];
}

// ========================================
// BULK SALARY UPDATE APIs
// ========================================

export const getSalaryFilterOptions = async () => {
  const response = await axiosInstance.get('api/salary-filter-options/');
  return response.data;
};

/**
 * Download Excel template for bulk salary update
 * @param {boolean} includeData - Include current employee salary data
 * @param {string} employeeNos - Comma-separated employee numbers
 * @param {object} filters - { location, branch }
 * @returns {Promise} - Template download
 */
export const downloadSalaryTemplate = async (includeData = false, employeeNos = '', filters = {}, templateType = 'salary') => {
  try {
    const params = new URLSearchParams();
    if (includeData) params.append('include_data', 'true');
    if (employeeNos) params.append('employee_nos', employeeNos);
    if (templateType) params.append('template_type', templateType);

    // Add filters
    if (filters.location) params.append('location', filters.location);
    if (filters.branch) params.append('branch', filters.branch);
    if (filters.manager) params.append('manager', filters.manager);
    if (filters.team_head) params.append('team_head', filters.team_head);

    const response = await axiosInstance.get(
      `api/bulk-salary-template/?${params.toString()}`,
      { responseType: 'blob' }
    );

    // Create download link
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', 'salary_update_template.xlsx');
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);

    return { success: true, message: 'Template downloaded successfully' };
  } catch (error) {
    console.error('Error downloading template:', error);
    throw error;
  }
};

/**
 * Upload Excel file with bulk salary updates
 * @param {File} file - Excel file from input
 * @param {object} filters - { location, branch }
 * @returns {Promise} - Response with success/failure details
 */
export const uploadBulkSalaryUpdate = async (file, filters = {}) => {
  try {
    const formData = new FormData();
    formData.append('file', file);

    // Add filters
    if (filters.location) formData.append('location', filters.location);
    if (filters.branch) formData.append('branch', filters.branch);
    if (filters.manager) formData.append('manager', filters.manager);

    const response = await axiosInstance.post('api/bulk-salary-update/', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });

    return response.data;
  } catch (error) {
    console.error('Error uploading bulk salary:', error);
    if (error.response?.data) {
      // Pass full error object if available (for detailed error list)
      throw error.response.data;
    }
    throw new Error('Upload failed');
  }
};

// Update loans/deductions
export const updateLoans = async (data) => {
  const response = await axiosInstance.post(`updateloans/`, {
    ...data,
    mode: 'update',
  });
  return response.data;
};

// Master Data Management APIs
export const GET_MANAGERS = async () => {
  const response = await axiosInstance.get('api/managers/');
  return response.data;
};
export const SAVE_MANAGER = async (data) => {
  const response = await axiosInstance.post('api/managers/', data);
  return response.data;
};
export const UPDATE_MANAGER = async (id, data) => {
  const response = await axiosInstance.put(`api/managers/${id}/`, data);
  return response.data;
};
export const DELETE_MANAGER = async (id) => {
  const response = await axiosInstance.delete(`api/managers/${id}/`);
  return response.data;
};

export const GET_BRANCHES = async () => {
  const response = await axiosInstance.get('api/branches/');
  return response.data;
};
export const SAVE_BRANCH = async (data) => {
  const response = await axiosInstance.post('api/branches/', data);
  return response.data;
};
export const UPDATE_BRANCH = async (id, data) => {
  const response = await axiosInstance.put(`api/branches/${id}/`, data);
  return response.data;
};
export const DELETE_BRANCH = async (id) => {
  const response = await axiosInstance.delete(`api/branches/${id}/`);
  return response.data;
};

export const GET_DEPARTMENTS = async () => {
  const response = await axiosInstance.get('api/v1/organization/departments/');
  return response.data;
};
export const SAVE_DEPARTMENT = async (data) => {
  const response = await axiosInstance.post('api/v1/organization/departments/', data);
  return response.data;
};
export const UPDATE_DEPARTMENT = async (id, data) => {
  const response = await axiosInstance.patch(`api/v1/organization/departments/${id}/`, data);
  return response.data;
};
export const DELETE_DEPARTMENT = async (id) => {
  const response = await axiosInstance.delete(`api/v1/organization/departments/${id}/`);
  return response.data;
};

export const GET_DESIGNATIONS = async () => {
  const response = await axiosInstance.get('api/v1/organization/designations/');
  return response.data;
};
export const SAVE_DESIGNATION = async (data) => {
  const response = await axiosInstance.post('api/v1/organization/designations/', data);
  return response.data;
};
export const UPDATE_DESIGNATION = async (id, data) => {
  const response = await axiosInstance.patch(`api/v1/organization/designations/${id}/`, data);
  return response.data;
};
export const DELETE_DESIGNATION = async (id) => {
  const response = await axiosInstance.delete(`api/v1/organization/designations/${id}/`);
  return response.data;
};

export const GET_COMPANY_SETTINGS = async () => {
  const response = await axiosInstance.get('api/v1/organization/settings/');
  return response.data;
};

export const UPDATE_COMPANY_SETTINGS = async (settings) => {
  const response = await axiosInstance.patch('api/v1/organization/settings/', {
    settings_json: settings,
  });
  return response.data;
};

export const GET_CUSTOM_FIELDS = async () => {
  const response = await axiosInstance.get('api/v1/organization/custom-fields/');
  return response.data;
};

export const SAVE_CUSTOM_FIELD = async (data) => {
  const response = await axiosInstance.post('api/v1/organization/custom-fields/', data);
  return response.data;
};

export const UPDATE_CUSTOM_FIELD = async (id, data) => {
  const response = await axiosInstance.patch(`api/v1/organization/custom-fields/${id}/`, data);
  return response.data;
};

export const DELETE_CUSTOM_FIELD = async (id) => {
  const response = await axiosInstance.delete(`api/v1/organization/custom-fields/${id}/`);
  return response.data;
};

export const GET_ORGANIZATION_HIERARCHY = async () => {
  const response = await axiosInstance.get('api/v1/organization/hierarchy/tree/');
  return response.data;
};

export const GET_LOCATIONS = async () => {
  const response = await axiosInstance.get('api/locations/');
  return response.data;
};
export const SAVE_LOCATION = async (data) => {
  const response = await axiosInstance.post('api/locations/', data);
  return response.data;
};
export const UPDATE_LOCATION = async (id, data) => {
  const response = await axiosInstance.put(`api/locations/${id}/`, data);
  return response.data;
};
export const DELETE_LOCATION = async (id) => {
  const response = await axiosInstance.delete(`api/locations/${id}/`);
  return response.data;
};

export const GET_HR_CONTACTS = async () => {
  const response = await axiosInstance.get('api/hr-contacts/');
  return response.data;
};
export const SAVE_HR_CONTACT = async (data) => {
  const response = await axiosInstance.post('api/hr-contacts/', data);
  return response.data;
};
export const UPDATE_HR_CONTACT = async (id, data) => {
  const response = await axiosInstance.put(`api/hr-contacts/${id}/`, data);
  return response.data;
};
export const DELETE_HR_CONTACT = async (id) => {
  const response = await axiosInstance.delete(`api/hr-contacts/${id}/`);
  return response.data;
};

export const GET_TEAM_HEADS = async () => {
  const response = await axiosInstance.get('api/team-heads/');
  return response.data;
};
export const SAVE_TEAM_HEAD = async (data) => {
  const response = await axiosInstance.post('api/team-heads/', data);
  return response.data;
};
export const UPDATE_TEAM_HEAD = async (id, data) => {
  const response = await axiosInstance.put(`api/team-heads/${id}/`, data);
  return response.data;
};
export const DELETE_TEAM_HEAD = async (id) => {
  const response = await axiosInstance.delete(`api/team-heads/${id}/`);
  return response.data;
};

export const getEmployeeAssets = async (employeeNo) => {
  const response = await axiosInstance.get(`api/employee/${employeeNo}/assets/`);
  return response.data;
};

export const addEmployeeAsset = async ({ employeeNo, assetData, file }) => {
  const formData = new FormData();
  formData.append('employee', employeeNo);
  formData.append('name', assetData.name);
  formData.append('quantity', assetData.quantity);
  formData.append('description', assetData.description);
  if (assetData.date_provided) formData.append('date_provided', assetData.date_provided);
  if (file) formData.append('attachment', file);

  const response = await axiosInstance.post('api/assets/', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return response.data;
};

export const deleteEmployeeAsset = async (assetId) => {
  const response = await axiosInstance.delete(`api/assets/${assetId}/`);
  return response.data;
};

// Careers job-opening management (admin/HR only).
export const getJobOpenings = async () => {
  const response = await axiosInstance.get('api/job-openings/');
  return response.data.data || [];
};

export const createJobOpening = async (payload) => {
  const response = await axiosInstance.post('api/job-openings/', payload);
  return response.data;
};

export const updateJobOpening = async ({ id, ...payload }) => {
  const response = await axiosInstance.patch(`api/job-openings/${id}/`, payload);
  return response.data;
};

export const deleteJobOpening = async (id) => {
  await axiosInstance.delete(`api/job-openings/${id}/`);
};

export const duplicateJobOpening = async (id) => {
  const response = await axiosInstance.post(`api/job-openings/${id}/duplicate/`);
  return response.data;
};

// Careers-site applications (admin/HR only).
export const getJobApplications = async (params = {}) => {
  const response = await axiosInstance.get('api/job-applications/', { params });
  return response.data.data || [];
};

export const updateJobApplicationStatus = async ({ id, status }) => {
  const response = await axiosInstance.patch(`api/job-applications/${id}/`, { status });
  return response.data;
};

export const moveApplicationToCandidates = async (id) => {
  const response = await axiosInstance.post(`api/job-applications/${id}/move-to-candidates/`);
  return response.data;
};
